export default {
    'app.booking-rooms': {
        'fields': {}
    },
    'app.booking': {
        'fields': {
            'rooms': ['app.booking-rooms']
        }
    }
}